import { toHandlers as _toHandlers, withKeys as _withKeys, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "id", "type", "value", "placeholder", "autocomplete"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldInputErrorMessage = _resolveComponent("FieldInputErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", _mergeProps(_toHandlers(_ctx.validationListeners, true), {
      name: _ctx.name,
      id: _ctx.name,
      type: _ctx.type,
      value: _ctx.inputValue,
      placeholder: _ctx.placeholder,
      autocomplete: _ctx.autocomplete,
      onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
      onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeyPress && _ctx.handleKeyPress(...args))),
      onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.keyupenter && _ctx.keyupenter(...args)), ["enter"])),
      ref: "inputRef"
    }), null, 16, _hoisted_1),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_FieldInputErrorMessage, {
          key: 0,
          errorMessage: _ctx.errorMessage
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}